/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_LocationInputs */

const en_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const fr_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieu`)
};

const es_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const it_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const nl_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locatie`)
};

const pl_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

const fi_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijainti`)
};

const da_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokation`)
};

const sv_salary_search_location = /** @type {(inputs: Salary_Search_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plats`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Salary_Search_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_location = /** @type {((inputs?: Salary_Search_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_location(inputs)
	if (locale === "fr") return fr_salary_search_location(inputs)
	if (locale === "es") return es_salary_search_location(inputs)
	if (locale === "it") return it_salary_search_location(inputs)
	if (locale === "nl") return nl_salary_search_location(inputs)
	if (locale === "pl") return pl_salary_search_location(inputs)
	if (locale === "fi") return fi_salary_search_location(inputs)
	if (locale === "da") return da_salary_search_location(inputs)
	if (locale === "sv") return sv_salary_search_location(inputs)
	return en_salary_search_location(inputs)
});